<template>
  <div class="page">
    <Header title="激活账号"></Header>
    <ActivationStep :activeNum="2"></ActivationStep>
    <div class="center-info">
      <div class="center-info-item center-item-box" >
        <van-cell title="公司名称" :value="clientInfo.clientName" />
        <van-cell title="姓名" :value="clientInfo.clientUserDTO&&clientInfo.clientUserDTO.userName" />
        <van-cell title="手机号" :value="clientInfo.clientUserDTO&&clientInfo.clientUserDTO.userMobile" />
        <van-cell title="所在地区" :value="clientInfo.provinceName+' '+clientInfo.cityName+' '+clientInfo.provinceName" />
        <van-cell title="详细地址" :value="clientInfo.detailAddress" />
        <van-cell title="邮箱" :value="clientInfo.clientUserDTO&&clientInfo.clientUserDTO.userMail" />
      </div>
    </div>
    <div class="activation_btn_box">
      <div class="btn agree_btn" @click="gotoWeb('next')">确认资料</div>
      <!-- <div class="btn disagree_btn" @click="gotoWeb()">我要修改</div> -->
    </div>

  </div>
</template>

<script>
import Header from '@/components/header'
import ActivationStep from '@/components/activation-step'
import centerApi from '../../api/center'
export default {
  components: {
    Header,
    ActivationStep
  },
  data () {
    return {
      clientInfo: {}
    }
  },
  created () {
    this.getClientInfo()
  },
  methods: {
    getClientInfo () {
      this.$toast.loading({
        duration: 0,
        forbidClick: true,
        mask: true,
        message: '加载中'
      })
      centerApi.getClientInfo().then(res => {
        this.$toast.clear()
        if (res.data.resultCode === '0') {
          this.clientInfo = res.data.resultData.clientInfo
          // this.params.applyInviteCode = clientInfo.applyInviteCode
        }
      })
    },
    gotoWeb (type) {
      if (type) {
        this.$router.push({ name: 'activation_step_three' })
      } else {
        this.$router.push({ name: 'activation_step_two_modification' })
      }
    }
  }
}
</script>

<style lang="less" scoped>
.center-info{
  margin: 0 15px;
  width: calc(100% - 30px);
}
.center-info-item{
  margin-top: 15px;
  padding-top: 0.1rem;
  padding-bottom: 0.06rem;
  background-color: #fff;
  // display: flex;
  // justify-content: space-evenly;
  // height: 60px;
  // line-height: 20px;
  // align-items: center;
  // text-align: center;
  //border-bottom: 5px solid #65bac7;
  border-radius: 5px;
}
</style>
